/**
 * Avatar de iniciais, com cor derivada do telefone.
 *
 * Cor estável por pessoa: a mesma conversa tem sempre o mesmo tom, então a
 * recepção reconhece a linha antes de ler o nome. Sete tons pastéis, todos
 * com par no escuro — cor viva ao lado de uma paleta contida lê como enfeite.
 */
const CORES = [
  { bg: "bg-[#e8f5e9] dark:bg-emerald-950/40", text: "text-[#2e7d32] dark:text-emerald-300" },
  { bg: "bg-[#ede7f6] dark:bg-purple-950/40", text: "text-[#5e35b1] dark:text-purple-300" },
  { bg: "bg-[#e0f2fe] dark:bg-sky-950/40", text: "text-[#0369a1] dark:text-sky-300" },
  { bg: "bg-[#fce4ec] dark:bg-pink-950/40", text: "text-[#c2185b] dark:text-pink-300" },
  { bg: "bg-[#fff3e0] dark:bg-amber-950/40", text: "text-[#e65100] dark:text-amber-300" },
  { bg: "bg-[#e0f2f1] dark:bg-teal-950/40", text: "text-[#00796b] dark:text-teal-300" },
  { bg: "bg-[#efebe9] dark:bg-stone-900/60", text: "text-[#4e342e] dark:text-stone-300" },
];

export function corAvatar(str: string) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) hash = str.charCodeAt(i) + ((hash << 5) - hash);
  return CORES[Math.abs(hash) % CORES.length];
}

export function Avatar({
  iniciais,
  telefone,
  tamanho = "sm",
}: {
  iniciais: string;
  telefone: string;
  tamanho?: "xs" | "sm" | "md" | "lg";
}) {
  const cor = corAvatar(telefone);
  const dimensao = tamanho === "lg" ? "h-[72px] w-[72px] text-2xl" : tamanho === "md" ? "h-10 w-10 text-sm" : tamanho === "xs" ? "h-8 w-8 text-xs" : "h-11 w-11 text-[14.5px]";
  return (
    <span className={`flex shrink-0 items-center justify-center rounded-full font-bold ${dimensao} ${cor.bg} ${cor.text}`}>
      {iniciais}
    </span>
  );
}
